<template>
  <div>
    <b-modal id="modal-help" hide-header-close hide-footer>
      <template #modal-header>
        <h2>{{ $t("configSite.modalHelp.title") }}</h2>
      </template>
      <template #default>
        <form @submit.prevent="handleSubmitForm" ref="formHelp">
          <div class="modal-help">
            <div class="modal-help__itens">
              <div class="row">
                <div class="col-12 col-lg-8">
                  <InputContact
                    :type="'text'"
                    :name="'name'"
                    :placeholder="modalHelp.placeholderName"
                    :is-required="true"
                  />
                </div>
                <div class="col-12 col-lg-4">
                  <InputContact
                    :type="'text'"
                    :name="'phone'"
                    :placeholder="modalHelp.placeholderTelphone"
                    :is-required="true"
                  />
                </div>
              </div>
              <div class="row">
                <div class="col-12 col-lg-5">
                  <InputContact
                    :type="'email'"
                    :name="'email'"
                    :placeholder="'Email'"
                    :is-required="true"
                  />
                </div>
                <div class="col-12 col-lg-5">
                  <InputContact
                    :type="'text'"
                    :name="'company'"
                    :placeholder="modalHelp.placeholderCompany"
                    :is-required="true"
                  />
                </div>
                <div class="col-12 col-lg-2">
                  <InputContact
                    :type="'text'"
                    :name="'nif'"
                    :placeholder="'NIF'"
                    :is-required="true"
                  />
                </div>
              </div>
              <div class="row">
                <div class="col-12">
                  <textarea
                    class="modal-help__textarea"
                    name="message"
                    :placeholder="modalHelp.placeholderMessage"
                    required
                  ></textarea>
                </div>
              </div>
            </div>
            <div class="modal-help-reason" v-if="false">
              <h3>Motivo do pedido</h3>
              <div class="modal-help-reason__body">
                <InputCheck
                  :name="'help-with-page-construction'"
                  :id="'help-with-page-construction'"
                  :label="'Ajuda na construção da página'"
                  @toggle-check-input="handleCheckedInput"
                />
                <InputCheck
                  :name="'config-domain'"
                  :id="'config-domain'"
                  :label="'Configuração do domínio'"
                  @toggle-check-input="handleCheckedInput"
                />
                <InputCheck
                  :name="'request-information'"
                  :id="'request-information'"
                  :label="'Pedido de informações'"
                  @toggle-check-input="handleCheckedInput"
                />
              </div>
            </div>
            <div class="modal-help-terms">
              <InputCheckTerms
                :name="'accepted_privacy_policy'"
                :id="'accepted_privacy_policy'"
                :is-required="true"
              />
            </div>
            <div class="modal-help-recaptcha">
              <vue-recaptcha
                ref="recaptcha"
                :sitekey="googleRecaptchaSite"
                :language="langActive"
              />
            </div>
          </div>
          <div class="modal-btns">
            <button
              type="button"
              class="btn-cancel"
              @click="$bvModal.hide('modal-help')"
            >
              {{ $t("configSite.btns.cancel") }}
            </button>
            <button class="btn-green" type="submit">
              {{ $t("configSite.btns.send") }}
            </button>
          </div>
        </form>
      </template>
    </b-modal>
  </div>
</template>

<script>
import InputContact from "@/components/inputs/InputContact.vue";
import InputCheck from "@/components/inputs/InputCheck.vue";
import InputCheckTerms from "@/components/inputs/InputCheckTerms.vue";
import { VueRecaptcha } from "vue-recaptcha";
import { mapGetters, mapActions } from "vuex";

export default {
  components: {
    InputContact,
    InputCheck,
    InputCheckTerms,
    VueRecaptcha,
  },
  computed: {
    ...mapGetters(["langActive", "userInfo"]),
  },
  data() {
    return {
      form: {
        lang: this.langActive,
        user_uuid: "",
        lead_type: 1,
        name: "",
        phone: "",
        email: "",
        company: "",
        nif: "",
        message: "",
        accepted_privacy_policy: 1,
      },
      arrayKeysCheckbox: ["accepted_privacy_policy"],
      googleRecaptchaSite: process.env.VUE_APP_GOOGLE_RECAPTCHA_SITE,
      modalHelp: {
        placeholderName: this.$t("configSite.modalHelp.placeholderName"),
        placeholderTelphone: this.$t(
          "configSite.modalHelp.placeholderTelphone"
        ),
        placeholderCompany: this.$t("configSite.modalHelp.placeholderCompany"),
        placeholderMessage: this.$t("configSite.modalHelp.placeholderMessage"),
      },
    };
  },
  methods: {
    ...mapActions(["sendLeads"]),
    async handleSubmitForm($event) {
      this.form.user_uuid = this.userInfo?.user_uuid;
      this.form.lang = this.langActive;

      const formData = new FormData($event.target);
      formData.forEach((value, key) => {
        if (!this.arrayKeysCheckbox.includes(key)) {
          this.form[key] = value;
        }
      });

      if (this.form["g-recaptcha-response"] === "") {
        this.$swal.fire({
          icon: "warning",
          html: this.$t("messageRecaptcha"),
        });

        return;
      }

      const { data } = await this.sendLeads(this.form);

      if (data?.success && "message" in data) {
        this.$swal.fire({
          icon: "success",
          html: data.message,
        });

        // clear form data
        this.$refs.formHelp.reset();
        this.$refs.recaptcha.reset();
        this.$bvModal.hide("modal-help");
      }
    },
    handleCheckedInput(value) {
      if (!value.isChecked) {
        const index = this.form.reason_for_request.indexOf(value.name);

        if (index > -1) {
          this.form.reason_for_request.splice(index, 1);
        }
        return;
      }

      this.form.reason_for_request.push(value.name);
    },
  },
};
</script>

<style lang="scss" scoped>
.modal-help {
  &-reason {
    h3 {
      font-size: 24px;
      font-family: "Font Bold";
      color: var(--color-black);
      margin-bottom: 25px;
      @media (max-width: 991px) {
        font-size: 22px;
        font-family: "Font Medium";
        margin-bottom: 20px;
      }
    }
    &__body {
      display: flex;
      align-items: center;
      gap: 40px;
      @media (max-width: 991px) {
        flex-direction: column;
        align-items: flex-start;
        gap: 20px;
      }
    }
  }
  &__textarea {
    position: relative;
    height: 120px;
    width: 100%;
    padding: 15px 25px;
    background: var(--color-white);
    border: 1px solid var(--color-gray-2);
    border-radius: 10px;
    font-size: 20px;
    font-family: "Font Regular";
    outline: none;
    @media (max-width: 991px) {
      height: 100px;
      font-size: 14px;
      border: 1px solid var(--color-black);
      padding: 15px 10px;
      border-radius: 10px;
    }
    &::-webkit-input-placeholder {
      /* Chrome/Opera/Safari */
      color: var(--color-gray);
    }
    &::-moz-placeholder {
      /* Firefox 19+ */
      color: var(--color-gray);
    }
    &:-ms-input-placeholder {
      /* IE 10+ */
      color: var(--color-gray);
    }
    &:-moz-placeholder {
      /* Firefox 18- */
      color: var(--color-gray);
    }
  }
}
</style>
